import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface UpdateEmsInput {
    emsId: string;
    locationId: string;
}

const updateEmsLocation = async (data: UpdateEmsInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/ems/location/update`,
        data,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useUpdateEmsLocation = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: UpdateEmsInput) => updateEmsLocation(data, sessionContext?.sessionId ?? null)
    });
}; 